/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { PlusIcon } from "src/components/shared/icon/TablerIcon";
import ObjavaCNRList from "./ObjavaCNRList";
import { Link, useSearchParams } from "react-router-dom";
import { resetPosts, showPosts, updatePostHash } from "src/store/objave-store";
import { useAppDispatch, useAppSelector } from "src/store";
import Pagination from "src/components/shared/Pagination";
import { BsSearch } from "react-icons/bs";
import api from "src/store/interceptors/api";
import moment from "moment";
import "moment/locale/sr";
import { showCategories } from "src/store/kategorija-store";
import { useExpireHash } from "src/context/ExpireHashContext";

const Objave = () => {
  const dispatch = useAppDispatch();
  const { posts, CEsuccess } = useAppSelector((state) => state.post);
  const [searchParams, setSearchParams] = useSearchParams();
  const { categories } = useAppSelector((state) => state.category);
  const [hash, setHash] = useState("");
  const [expireHash, setExpireHash] = useState("");

  const { setExpireHashShare } = useExpireHash();

  const [isLoadingresetHash, setIsLoadingresetHash] = useState(false);
  const [page, setPage] = useState(parseInt(searchParams.get("page") || "1"));
  const [search, setSearch] = useState(searchParams.get("search[title]") || "");
  const [category, setCategory] = useState<any>(
    searchParams.get("exact_search[load_categories.post_category_id]") || ""
  );
  const [type, setType] = useState(
    searchParams.get("exact_search[type]") || "objave"
  );
  const [data, setData] = useState<any>({
    page,
    "search[title]": search,
    per_page: 10,
    "exact_search[type]": type,
    "exact_search[load_categories.post_category_id]": category,
  });

  const getHashLink = async () => {
    await api.get("/latest-hash-link").then((res) => {
      setHash(res.data.data.hash);
      setExpireHash(res.data.data.hash_expires_at);
      setExpireHashShare(res.data.data.hash_expires_at)
      dispatch(updatePostHash(res.data.data.hash));
    });
  };

  function isDateExpired(date: any) {
    const currentDate = new Date();
    const inputDate = new Date(date);

    return inputDate < currentDate;
  }

  useEffect(() => {
    setSearchParams(data);
    dispatch(showPosts(data));
    dispatch(showCategories({ per_page: 1000 }));
    dispatch(resetPosts());
    getHashLink();
  }, [CEsuccess]);

  useEffect(() => {
    if (
      CEsuccess &&
      posts &&
      posts?.data &&
      posts?.data.length === 0 &&
      data.page &&
      data.page > 1
    ) {
      window.location.href = `/objave`;
      dispatch(resetPosts());
    }
  }, [CEsuccess]);

  const resetHash = async () => {
    setIsLoadingresetHash(true);
    await api
      .post("/hash-link")
      .then((res: any) => {
        setHash(res.data.data.hash);
        setExpireHash(res.data.data.hash_expires_at);
        dispatch(updatePostHash(res.data.data.has));
      })
      .finally(() => {
        setIsLoadingresetHash(false);
      });
  };

  const getObjave = (vrstaObjave: string) => {
    const params = {
      ...data,
      page: 1,
      "exact_search[type]": vrstaObjave,
    };
    setType(vrstaObjave);
    setData(params);
    setSearchParams(params);
    dispatch(showPosts(params));
  };

  const getObjaveByCategory = (id: number | string) => {
    const params = {
      ...data,
      page: 1,
      "exact_search[load_categories.post_category_id]": id,
    };
    setCategory(id);
    setData(params);
    setSearchParams(params);
    dispatch(showPosts(params));
  };

  const getObjaveSerach = (value: string) => {
    const params = {
      ...data,
      "search[title]": value,
    };
    setSearch(value);
    setData(params);
    setSearchParams(params);
    dispatch(showPosts(params));
  };

  return (
    <div className="objave mb-5">
      <div className="title-first row g-2 align-items-center">
        <div className="col">
          <h2 className="page-title">Objave</h2>
        </div>
        <div className="col-auto ms-auto d-print-none">
          <div className="btn-list">
            <Link
              to="/objave/nova-objava"
              className="btn btn-primary"
            >
              <PlusIcon />
              Dodaj Objavu
            </Link>
          </div>
        </div>
      </div>

      <div className="card">
        <div className="card-header d-flex justify-content-between flex-wrap">
          <div className="text-truncate ">
            {hash && (
              <Link
                target="_blank"
                to={`/interne-objave/${hash}`}
                className={`form-check-label text-wrap ${
                  expireHash && isDateExpired(expireHash) ? "text-danger" : ""
                }`}
              >
                {window.location.origin}/interne-objave/{hash}
              </Link>
            )}
            <div className="mt-2">
              {expireHash && hash && (
                <p>
                  {expireHash && hash && isDateExpired(expireHash)
                    ? `Link je istekao: ${moment(expireHash).format(
                        "DD. MMMM YYYY"
                      )}`
                    : `Link važi do: ${moment(expireHash).format(
                        "DD. MMMM YYYY"
                      )}`}
                </p>
              )}
            </div>{" "}
          </div>

          <div className="text-end ">
            <button
              disabled={isLoadingresetHash}
              onClick={resetHash}
              className="btn btn-primary"
            >
              {isLoadingresetHash
                ? "U obradi..."
                : hash
                ? "Reset link"
                : "Kreiraj link"}
            </button>
          </div>
        </div>

        <div className="card-header card-header-objave">
          <ul className="nav nav-tabs card-header-tabs" role="tablist">
            <li
              role="presentation"
              className={`${type === "objave" ? "active" : ""}`}
            >
              <a
                href={type}
                className={`${
                  type === "objave" ? "active" : ""
                } nav-link`}
                aria-controls={type}
                role="tab"
                data-bs-toggle="tab"
                onClick={() => getObjave("objave")}
              >
                Javne objave
              </a>
            </li>
            <li
              role="presentation"
              className={`${type === "interne_objave" ? "active" : ""}`}
            >
              <a
                href={type}
                className={`${
                  type === "interne_objave" ? "active" : ""
                } nav-link`}
                aria-controls={type}
                role="tab"
                data-bs-toggle="tab"
                onClick={() => getObjave("interne_objave")}
              >
                Interne objave
              </a>
            </li>
          </ul>

          <div className="d-flex w-50 card-header-search">
            {categories && categories.data && categories.data.length > 0 && (
              <select
                className="form-select me-1 category-select"
                aria-label="Default select example"
                onChange={(e: any) => getObjaveByCategory(e.target.value)}
                value={category}
              >
                <option value="">Sve</option>
                {categories &&
                  categories.data &&
                  categories.data.length > 0 &&
                  categories.data.map((item: any) => (
                    <option key={item.id} value={item.id}>
                      {item.name}
                    </option>
                  ))}
              </select>
            )}

            <div className="position-relative w-100">
              <input
                value={search}
                onChange={(e) => getObjaveSerach(e.target.value)}
                type="text"
                className="form-control input-search"
                placeholder="Pretražite objavu "
              />
              <div className="button-search">
                <BsSearch />
              </div>
            </div>
          </div>
        </div>

        <div className="card-table table-responsive">
          <div className="tab-content">
            <div>
              <table className="table table-vcenter table-fixed">
                <thead>
                  <tr>
                    <th>Naslov</th>
                    <th>Sadržaj</th>
                    <th>Datum</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <ObjavaCNRList data={data} listaOCNR={posts?.data} />
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {posts?.meta && (
          <Pagination
            meta={posts?.meta}
            setPage={setPage}
            data={data}
            switchFunction={showPosts}
            path="objave"
          />
        )}
      </div>
    </div>
  );
};

export default Objave;
